import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/authContext";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import SignupPage from "@/pages/SignupPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import DashboardLayout from "@/pages/app/DashboardLayout";
import DashboardHome from "@/pages/app/DashboardHome";
import ChatPage from "@/pages/app/ChatPage";
import TicketsPage from "@/pages/app/TicketsPage";
import NewTicketPage from "@/pages/app/NewTicketPage";
import TicketDetailPage from "@/pages/app/TicketDetailPage";
import KnowledgeBasePage from "@/pages/app/KnowledgeBasePage";
import KBArticlePage from "@/pages/app/KBArticlePage";
import DiagnosePage from "@/pages/app/DiagnosePage";
import TeamPage from "@/pages/app/TeamPage";
import TermsPage from "@/pages/legal/TermsPage";
import PrivacyPage from "@/pages/legal/PrivacyPage";
import ServiceAgreementPage from "@/pages/legal/ServiceAgreementPage";
import RefundPolicyPage from "@/pages/legal/RefundPolicyPage";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50">
        <div className="text-zinc-400 font-mono text-xs">Loading…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/service-agreement" element={<ServiceAgreementPage />} />
          <Route path="/refund-policy" element={<RefundPolicyPage />} />
          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardHome />} />
            <Route path="chat" element={<ChatPage />} />
            <Route path="diagnose" element={<DiagnosePage />} />
            <Route path="team" element={<TeamPage />} />
            <Route path="tickets" element={<TicketsPage />} />
            <Route path="tickets/new" element={<NewTicketPage />} />
            <Route path="tickets/:id" element={<TicketDetailPage />} />
            <Route path="kb" element={<KnowledgeBasePage />} />
            <Route path="kb/:id" element={<KBArticlePage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
